import { render, staticRenderFns } from "./CreateAccessorial.vue?vue&type=template&id=4d16c13e&scoped=true"
import script from "./CreateAccessorial.vue?vue&type=script&lang=js"
export * from "./CreateAccessorial.vue?vue&type=script&lang=js"
import style0 from "./CreateAccessorial.vue?vue&type=style&index=0&id=4d16c13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16c13e",
  null
  
)

export default component.exports